import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CanActivateDashboard } from './can-activate-dashboard';
import { DashboardComponent } from './dashboard.component';

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                canActivateChild: [CanActivateDashboard],
                children: [
                    {path: '', component: DashboardComponent}
                ]
            }
        ])
    ],
    exports: [
        RouterModule
    ],
    providers: [
        CanActivateDashboard
    ]
})
export class DashboardRoutingModule { }
